<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ao0L70/tc-custom/9780253008107.jpg?1705379643282" alt="This image is the cover for the book Free and French in the Caribbean, Blacks in the Diaspora"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Free and French in the Caribbean, Blacks in the Diaspora
      </h1>
      <p class="bookDescription body article font2">
        <b>“All the ingredients to become the next important book in the field of postcolonial studies with the emphasis on French Caribbean culture and literature.”—Daniel Desormeaux, University of Chicago</b><br/>  <br/><i>In Free and French in the Caribbean</i>, John Patrick Walsh studies the writings of Toussaint Louverture and Aimé Césaire to examine how they conceived of and narrated two defining events in the decolonializing of the French Caribbean: the revolution that freed the French colony of Saint-Domingue in 1803 and the departmentalization of Martinique and other French colonies in 1946. Walsh emphasizes the connections between these events and the distinct legacies of emancipation in the narratives of revolution and nationhood passed on to successive generations. By reexamining Louverture and Césaire in light of their multilayered narratives, the book offers a deeper understanding of the historical and contemporary phenomenon of “free and French” in the Caribbean.<br/> “A fruitful intervention in a growing body of literature and increasingly lively debate on the Haitian Revolution and the figure of Toussaint Louverture, the book also contributes to the emerging scholarship on Césaire, Francophone literature, and postcolonial theory.”—Gary Wilder, CUNY Graduate Center<br/> “A valuable contribution to both the rapidly proliferating literature on the Haitian Revolution and the emerging revisionist appreciation of Césaire’s intellectual and political project.”—<i>Small Axe</i><br/>  <br/> “J.P. Walsh has produced for the nonspecialist reader an excellent analysis of the historiographical discourse on Toussaint Louverture and Aimé Césaire with a focus on the meaning(s) of decolonization in the late eighteenth and mid-twentieth centuries.”—<i>New West Indian Guide</i><br/>  <br/> “<i>That Free and French</i> inspires so many questions is testament to its ambition, the provocative parallel at its heart, and the richness of Walsh’s analysis.”—<i>H-Empire</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Patrick Walsh
      </h2>
      
      <p class="authorDescription body article">John Patrick Walsh is Assistant Professor of French and Francophone Studies at the University of Pittsburgh.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?098c9b9e